import { NoMembership } from "lib/apollo/constants"

export const mapHotJarMembershipTerm = (
  id: string | undefined,
  duration: string | undefined
): string => {
  if (!id || id === NoMembership.id || !duration) return ""

  return duration === "none" ? "unknown" : duration
}
